import { TeamOutlined } from '@ant-design/icons';
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';
import { FormattedMessage } from 'react-intl';

const icons = { TeamOutlined };

export const affiliateCommunity: NavItemType = {
  id: 'affiliate-community-menu',
  type: 'group',
  children: [
    {
      id: 'affiliates',
      title: <FormattedMessage id="affiliates" />,
      type: 'collapse',
      icon: icons.TeamOutlined,
      children: [
        {
          id: 'affiliates-finder',
          title: <FormattedMessage id="affiliates-finder" />,
          type: 'item',
          url: '/affiliates/affiliates-finder'
        },
        {
          id: 'my-community',
          title: <FormattedMessage id="my-community" />,
          type: 'item',
          url: '/affiliates/my-community'
        },
        {
          id: 'my-lists',
          title: <FormattedMessage id="my-lists" />,
          type: 'item',
          url: '/affiliates/my-lists'
        }
      ]
    }
  ]
};

export const simplifiedAffiliateCommunity: NavItemType = {
  id: 'affiliate-community-menu',
  type: 'group',
  children: [
    {
      id: 'affiliates',
      title: <FormattedMessage id="affiliates" />,
      type: 'collapse',
      icon: icons.TeamOutlined,
      children: [
        {
          id: 'my-community',
          title: <FormattedMessage id="my-community" />,
          type: 'item',
          url: '/affiliates/my-community'
        },
        {
          id: 'my-lists',
          title: <FormattedMessage id="my-lists" />,
          type: 'item',
          url: '/affiliates/my-lists'
        }
      ]
    }
  ]
};
